export default "__VITE_ASSET__CR5zfCF3__"